import React from 'react'
import { Link } from 'react-router-dom';
import { practiceAreas } from './data';
import BgImage from "../../images/practiceArea/contract.jpeg";

const PracticeAreas = () => {
  return (
    <div className="workSans">
      <section
        className="relative h-[400px] md:h-[450px] flex items-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(5, 33, 55, 0.9), rgba(5, 33, 55, 0.9)), url(${BgImage})`,
        }}
      >
        <div className="container mx-auto px-6 md:px-12 text-white z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-3">Practice Areas</h1>

          <div className="flex items-center text-sm md:text-base space-x-2 mb-6">
            <Link to="/" className="text-blue-300 hover:underline">
              Home
            </Link>
            <span className="text-[#d11c1c] font-bold">»</span>
            <span className="text-white">Practice Areas</span>
          </div>

          <hr className="border-t border-white opacity-10 mb-6" />

          <Link
            to="/book"
            className="inline-block bg-[#d11c1c] text-white text-xs md:text-sm font-semibold tracking-wide uppercase py-3 px-6 rounded-sm shadow hover:bg-[#b81616] transition"
          >
            Speak with a Senior Legal Consultant →
          </Link>
        </div>
      </section>
      <div className="px-[6%] my-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 my-4">
          {practiceAreas.map((item, index) => (
            <div key={index} className="bg-[#FAFAFA] rounded-md py-6 px-4">
              <div className="my-4">
                {item.item.map((practice, index) => (
                  <div key={index}>
                    <Link to={`/areas-of-practice/${practice.title.toLowerCase().replace(/\s+/g, '-')}`}>
                      <p className="text-[14px] p-4 hover:bg-[#05213787] rounded-md cursor-pointer">{practice.title}</p>
                    </Link>
                    <hr />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default PracticeAreas;
